(() => {
  if (!window.Shopify?.designMode || window.__clpImageInfoEditor) return;
  window.__clpImageInfoEditor = true;
  const openedByEditor = new WeakSet();
  document.addEventListener('shopify:block:select', event => {
    const info = event.target.closest?.('.clp-image-info--editable');
    if (info && !info.open) {
      openedByEditor.add(info);
      info.open = true;
    }
  });
  document.addEventListener('shopify:block:deselect', event => {
    const info = event.target.closest?.('.clp-image-info--editable');
    if (info && openedByEditor.has(info)) {
      info.open = false;
      openedByEditor.delete(info);
    }
  });
})();
